/**
 *
 * @page 企业中心/数据看板/项目经理界面
 *
 **/

import OverviewCard from './OverviewCard';
import MesaggeCard from './MesaggeCard';
import StatusStatistics from './StatusStatistics';
import SatisfactionStatistics from './SatisfactionStatistics';
import QualityStatistics from './QualityStatistics';
import FinishRate from './FinishRate';
import PostponeCard from './PostponeCard';
import { getAllData } from '@/api/personCenter/dataBoard';
import { DAY_OPTIONS } from './constants';
import { useStoreState } from '&/utils/customHooks';
import './ManagerPage.scss';

function ManagerPage() {
    const baseParams = {
        dap: 2,
        days: 30,
    };

    const appStore = useStoreState('appStore');
    const { userInfo } = appStore;
    const { userId } = userInfo || {};

    useEffect(() => {
        queryAllData();
    }, []);

    // 查询所有数据

    const [compositeData, setCompositeData] = useState({
        getProjectOverall: {},
    });

    function queryAllData() {
        getAllData(baseParams).then(({ data }) => {
            setCompositeData(data);
        });
    }

    return (
        <div className="manager-page grid-wrap">
            <OverviewCard
                defaultValue={compositeData.getProjectOverall}
                baseParams={baseParams}
            />
            <MesaggeCard
                defaultValue={compositeData.getMessageWaitAndSteward}
                baseParams={baseParams}
            />
            <StatusStatistics
                defaultValue={compositeData.getProjectStatus}
                baseParams={baseParams}
                dayOpts={DAY_OPTIONS(intl)}
                userId={userId}
            />
            <FinishRate
                defaultValue={compositeData.getProjectDelayOrFinish}
                baseParams={baseParams}
                userId={userId}
            />
            <SatisfactionStatistics
                defaultValue={compositeData.getProjectOpinion}
                baseParams={baseParams}
                dayOpts={DAY_OPTIONS(intl)}
                userId={userId}
            />
            <QualityStatistics
                defaultValue={compositeData.getExamineQuality}
                baseParams={baseParams}
                dayOpts={DAY_OPTIONS(intl)}
                userId={userId}
            />
            <PostponeCard defaultValue={compositeData.getProjectDelayList} />
        </div>
    );
}

export default ManagerPage;
